"use client";

import React from "react";
import { InfiniteSlider } from '@/components/ui/infinite-slider';
import { ProgressiveBlur } from '@/components/ui/progressive-blur';
import { LogoCloudsSvg } from './logo-clouds-svgs';
import { useTranslations } from 'next-intl';


// export const LogoCloudsSvg = {
//     rheem: Rheem,
//     bmw: Bmw,
//     aeropost: Aeropost,
//     allianz: Allianz,
//     att: Att,
//     deel: Deel,
//     ea: Ea,
//     globant: Globant,
//     hubspot: Hubspot,
//     orangeEnergy: OrangeEnergy,
//     ford: Ford,
//     sensorTower: SensorTower,
//     elektra: Elektra,
// }


export default function LogoClouds() {
    const t = useTranslations('home.agent.logoClouds');

    return (
        <section className="second-screen pt-12 md:pt-16 lg:pt-24 overflow-x-hidden">
            <div className="container mx-auto max-w-7xl px-5 md:px-8 relative">



                <div className="flex w-full flex-col justify-between gap-7 md:flex-row items-center">
                    <span className="text-14 leading-tight font-medium tracking-2 text-gray-60 uppercase md:mt-1 lg:text-15 shrink-0">
                        {t('title1')} <br /> {t('title2')}
                    </span>

                    <div className="relative flex-1 min-w-0 overflow-hidden max-w-screen">
                        <InfiniteSlider className='flex h-full w-full items-center' >
                            <div className='flex h-full w-full items-center gap-12 px-6'>

                                <div className='w-14 text-center text-black dark:text-white'>
                                    <LogoCloudsSvg.rheem className="w-full" />
                                </div>

                                <div className='w-32 text-center text-4xl font-[450] text-black dark:text-white'>
                                    <LogoCloudsSvg.allianz className="w-full" />
                                </div>
                                <div className='w-32 text-black dark:text-white items-center justify-center'>
                                    <LogoCloudsSvg.elektra className="w-full" />
                                </div>
                                <div className='w-28 text-center text-4xl font-[450] text-black dark:text-white'>
                                    <LogoCloudsSvg.atyt className="w-full" />
                                </div>
                                <div className='w-22 text-center text-4xl font-[450] text-black dark:text-white'>
                                    <LogoCloudsSvg.deel className="w-full" />
                                </div>
                                <div className='w-20 text-center text-4xl font-[450] text-black dark:text-white'>
                                    <LogoCloudsSvg.ea className="w-full" />
                                </div>
                                <div className='w-34 text-center text-4xl font-[450] text-black dark:text-white'>
                                    <LogoCloudsSvg.globant className="w-full" />
                                </div>
                                <div className='w-14 text-center text-4xl font-[450] text-black dark:text-white'>
                                    <LogoCloudsSvg.bwm className="w-full" />
                                </div>
                                <div className='w-32 text-center text-4xl font-[450] text-black dark:text-white'>
                                    <LogoCloudsSvg.ford className="w-full" />
                                </div>
                                <div className='w-32 text-center text-4xl font-[450] text-black dark:text-white'>
                                    <LogoCloudsSvg.hubspot className="w-full" />
                                </div>
                            </div>
                        </InfiniteSlider>
                        <ProgressiveBlur
                            className='pointer-events-none absolute top-0 left-0 h-full w-[50px] md:w-[200px] hidden md:block'
                            direction='left'
                            blurIntensity={1}
                        />
                        <ProgressiveBlur
                            className='pointer-events-none absolute top-0 right-0 h-full w-[50px] md:w-[200px] hidden md:block'
                            direction='right'
                            blurIntensity={1}
                        />
                        <div className='pointer-events-none absolute top-0 left-0 h-full w-[50px] md:w-[200px] z-10 bg-gradient-to-r from-white to-transparent from-30%' />
                        <div className='pointer-events-none absolute top-0 right-0 h-full w-[50px] md:w-[200px] z-10 bg-gradient-to-l from-white to-transparent from-30%' />
                    </div>

                </div>

            </div>

        </section>
    );
}


